module.exports = __webpack_public_path__ + "static/developer-da9f8da6db89ad201d3498e87670ed4a.png";